import { lazy } from 'react';

import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const ListTipoNotificacionView = Loadable(lazy(() => import('views/user/NotificacionesView/ListTipoNotificacionView')));
const NewTipoNotificacionView = Loadable(lazy(() => import('views/user/NotificacionesView/NewTipoNotificacionView')));
const ListNotificacionView = Loadable(lazy(() => import('views/user/NotificacionesView/ListNotificacionView/index')));

const NotificacionesRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/list-tipo-notificacion',
            element: <ListTipoNotificacionView />
        },
        {
            path: '/user/new-tipo-notificacion/:id_tipo_notificacion',
            element: <NewTipoNotificacionView />
        },
        {
            path: '/user/list-notificacion',
            element: <ListNotificacionView />
        }
    ]
};

export default NotificacionesRoutes;
